import React from 'react';
import {AisinoFormItem} from "../../../baseComponent/form";
import {formItemTailLayout} from "../../../constant/css";
import CommonUrlSelect from "./commonUrlSelect";


class FormItemUrlSelect extends React.Component {
    loadSelectData(url,param,type){
        this.refs.select.loadSelectData(url,param,type);
    }
    setSelectData(data){
        this.refs.select.setSelectData(data);
    }
    getData(){
        return this.refs.select.getData();
    }
    getSelected(selected){
        return this.refs.select.getSelected(selected);
    }
    render() {
        return(
            <AisinoFormItem  {...formItemTailLayout}
                             {...this.props} onChange={this.props.onChangeItem}>
                <CommonUrlSelect ref={"select"} {...this.props}/>
            </AisinoFormItem>
        );
    }
}
export default FormItemUrlSelect;